<template>
  <div class="flickity-container" v-if="slides.length">
    <flickity :class="['flickity']" ref="flickity" v-on:init="flickityInit" :options="flickityOptions">
      <vue-link
        v-for="(slide, i) in slides"
        :to="slide.active ? slide.url : false"
        :key="slide.url + i"
        tabindex="-1"
        :class="[
          'image-container',
          {
            active: active === i,
            'noisy-image-invert': loaded.indexOf(i) >= 0,
          },
        ]"
      >
        <div class="image" :data-flickity-bg-lazyload="slide.homeimage.medium" :alt="slide.title"></div>
      </vue-link>
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'ScrubSlides',
  components: { Flickity },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: this.$store.state.slideshow.index || 0,
      loaded: [],
    }
  },
  computed: {
    mobile() {
      return this.$store.state.mobile
    },
    initialIndex() {
      return this.$store.state.slideshow.index || 0
    },
    flickityOptions() {
      return {
        bgLazyLoad: 1,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        wrapAround: true,
        autoPlay: 4000,
        pauseAutoPlayOnHover: false,
        initialIndex: this.initialIndex,
      }
    },
  },
  methods: {
    flickityInit() {
      this.$store.commit('updateSlideshowMeta', {
        title: this.slides[this.active].title,
        year: this.slides[this.active].year,
        category: this.slides[this.active].category,
      })

      this.$refs.flickity.on('dragStart', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'none'
      })
      this.$refs.flickity.on('dragEnd', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'auto'
      })
      this.$refs.flickity.on('select', () => {
        const index = this.$refs.flickity.selectedIndex()
        this.active = index
        this.$store.commit('updateSlideshowMeta', {
          title: this.slides[index].title,
          year: this.slides[index].year,
          category: this.slides[index].category,
          index: index,
        })
      })
      this.$refs.flickity.on('bgLazyLoad', (e, el) => {
        let index = [...el.parentNode.parentNode.children].indexOf(el.parentNode)
        this.loaded.push(index)

        // show paw once first slide is loaded
        if (index === this.initialIndex) {
          this.$store.commit('updateSlideshowMeta', { paw: true })
        }
      })
    },
  },
  beforeDestroy() {
    const index = this.$refs.flickity.selectedIndex()
    const slides = this.$refs.flickity.slides().length
    const nextIndex = index + 1 >= slides ? 0 : index + 1
    this.$store.commit('updateSlideshowMeta', {
      paw: false,
      index: nextIndex,
    })
  },
}
</script>

<style scoped>
.flickity-container {
  position: relative;
  cursor: pointer;
  height: 100%;
  width: 100%;
  z-index: 3;
}

.flickity {
  height: 100%;
}

.image-container {
  height: 100%;
  width: 100%;
}

.image {
  background-size: cover;
  background-position: center;
  position: absolute;
  height: 100%;
  width: 100%;
}

.flickity >>> .flickity-viewport {
  height: 100% !important;
}

.flickity-fade >>> .flickity-slider {
  transform: none !important;
}

.flickity-fade >>> .flickity-slider > * {
  left: 0 !important;
  opacity: 0;
  z-index: 1;
  transition: opacity 1s ease-in-out 0.15s;
}

.flickity-fade >>> .flickity-slider > .active {
  opacity: 1;
  z-index: 2;
  transition: opacity 1s ease-in-out;
}

/* flickity-fade */
/*.flickity-enabled.is-fade .flickity-slider > * {
  z-index: 0;
}

.flickity-enabled.is-fade .flickity-slider > .is-selected,
.flickity-enabled.is-fade .flickity-slider > .active {
  z-index: 1;
}*/
</style>
